import { ResourceLanguage } from 'i18next'

const translation = {
    common: {
        atjVehicleType_car: 'Car',
        atjVehicleType_atv: 'All-terrain vehicle',
        atjVehicleType_motorbike: 'Motorcycle',
        atjVehicleType_moped: 'Moped',
        atjVehicleType_trailer: 'Trailer',
        atjVehicleType_tractor: 'Tractor/work machine',
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'Terms of Use',
        registerDescription: 'Register Description',
        save: 'Save',
        yes: 'Yes',
        no: 'No',
        ok: 'OK',
        cancel: 'Cancel',
        campaignCode: 'Campaign Code',
        no_campaign_code: 'No campaign code',
        customer: 'Customer',
        accept: 'Accept',
        price: 'Price',
        paymentType: 'Payment Method',
        personReserving: 'Reserver',
        vehicle: 'Vehicle',
        station: 'Station',
        service: 'Service',
        time: 'Time',
        time_of_day: 'at',
        time_of_day_abbr: 'at',
        fuel: 'Fuel',
        fuel_diesel: 'Diesel',
        fuel_diesel_electricity: 'Diesel/Electric',
        fuel_electricity: 'Electric',
        fuel_gas: 'Gas',
        fuel_no_engine: 'Vehicle without engine',
        fuel_petrol: 'Petrol',
        fuel_petrol_electricity: 'Petrol/Electric',
        fuel_unknown: '-',
        manual_vehicle_group_car: 'Passenger car',
        manual_vehicle_group_van: 'Van',
        manual_vehicle_group_camper: 'Motorhome',
        manual_vehicle_group_truck_light: 'Light truck with hydraulic brakes',
        manual_vehicle_group_truck_max12t: 'Truck max. 12,000 kg',
        manual_vehicle_group_truck_over12t: 'Truck over 12,000 kg',
        manual_vehicle_group_bus_max5t: 'Bus max 5,000 kg',
        manual_vehicle_group_bus_over5t: 'Bus over 5,000 kg',
        manual_vehicle_group_moped: 'Moped',
        manual_vehicle_group_mopedcar: 'Light quadricycle',
        manual_vehicle_group_atv: 'ATV',
        manual_vehicle_group_trailer_max3500: 'Trailer max. 3,500 kg',
        manual_vehicle_group_trailer_max10t: 'Trailer max. 10,000 kg',
        manual_vehicle_group_trailer_over10t: 'Trailer over 10,000 kg',
        registrationDate: 'Date of first registration',
        reservation: 'Booking',
        reservationInfo: 'Booking information',
        vehicleGroup: 'Vehicle category',
        vehicleType: 'Vehicle type',
        postalAddress: 'Mailing address',
        postalCode: 'Postal code',
        postOffice: 'City',
        week: 'Week',
        choose: 'Select',
        submit: 'Submit',
        back: 'Previous',
        next: 'Next',
        continue: 'Continue',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone number',
        registrationNumber: 'Registration number',
        close: 'Close',
        total: 'Total'
    },
    errors: {
        postOffice: 'Invalid city',
        postalAddress: 'Invalid mailing address',
        postalCode: 'Invalid postal code',
        register: 'Invalid registration number',
        firstName: 'Invalid first name',
        lastName: 'Invalid last name',
        email: 'Invalid email address',
        phone: 'Invalid phone number',
        timeNotAvailable: 'The selected time is not available',
        paymentFailed: 'Payment failed',
        cancelFailed: 'Failed to cancel the reservation. Please contact the station.',
        required: 'Required field',
    },
    cancelledReservationContainer: {
        reservationCancelled: 'Your reservation has been cancelled.',
        cancelledParagraph: 'Your reservation has been successfully cancelled.',
        newReservation: 'You can make a new reservation here',
    },
    reservationDoneContainer: {
        thankYou: 'Thank you for your reservation!',
        thankYouParagraph: 'A confirmation with a link to the service card has been sent to you, where you can review your reservation details.',
        serviceCardFromHere: 'You can also access the service card from here.',
        paymentFailed: 'Payment failed!',
        paymentFailedParagraph: 'Your reservation was successful. A confirmation with a link to the service card has been sent to you, where you can review your reservation details. You can also try to pay for the service online through the service card.',
    },
    serviceCardContainer: {
        serviceCard: 'Service card',
        reportHelperText: 'You can download the inspection report and receipt from here.',
        feedbackSubmitOk: 'Thank you for your feedback!',
        createCalendarEvent: 'Add to calendar',
        feedbackText: 'Written feedback',
        feedbackTitle: 'Give feedback',
        confirmParagraph: 'By canceling the booking, you accept the cancellation terms.',
        changeTimeTooltip: 'The time can be changed {{time}} before the booking starts',
        changeServiceTooltip: 'The service can be changed {{time}} before the booking starts',
        checkInHelperText: 'Check-in opens {{time}} before the booking starts, if payment has been made in advance.',
        cancelHelperText: 'The booking can be canceled {{time}} before it starts. If you have already paid, the payment will be refunded automatically.',
        paymentHelperText: 'Prepayment is possible {{time}} before the booking starts',
        paymentFailed: 'Payment failed.',
        paymentInProgress: 'Payment processing in progress',
        dateSubmitOk: 'Inspection time changed to: \n{{time}}',
        serviceSubmitOk: 'Service changed to: {{service}}',
        changeService: 'Change service',
        changeTime: 'Change time',
        clock: 'Time',
        grade: 'Inspection grade',
        gradeOffice: 'Office grade',
        inspection: 'Inspection',
        inspectReady: 'The inspection has been completed.',
        refundInProgress: 'Refund processing in progress',
        reservationDate: 'Your booking time',
        reservationCancelled: 'Your booking has been cancelled',
        checkedIn: 'You are checked in. Your booking starts {{time}}.',
        checkInFailed: 'Self-service check-in failed. Please check in at the station before the inspection.',
        confirmCancelReservation: 'Do you want to cancel your booking?',
        paymentFulfilled: 'Payment completed ({{price}} incl. VAT {{vat}})',
        paymentRefunded: 'Payment refunded',
        prepaidPrice: 'Online payment',
        normalPrice: 'Payment at the station',
        servicePrice: 'Service price',
        confirmCheckIn: 'Do you want to check in?',
        confirmCheckInContent: 'By confirming, you verify your check-in for the scheduled inspection.',
        changeReservation: 'Modify booking',
        cancelReservation: 'Cancel booking',
        office: 'Office',
        checkIn: 'Check in',
        payNow: 'Pay now',
        showDocuments: 'Show documents',
        documents: 'Documents',
        showOnMap: 'Show on map',
        downloadReceipt: 'Download receipt',
        downloadCertificate: 'Download inspection certificate',
        wantsResponse: 'I would like a response to my feedback',
    },
    reminderSettings: {
        title: 'Subscribe to inspection reminders',
        submit: 'Submit',
    },
    rootContainer: {
        checkInfo: {
            heading: 'Check for missing/incorrect information',
            acceptTermsOfUse: 'I accept the terms of service',
            vehicleOwnership: 'Vehicle owner/holder',
        },
        inviteAddressInfo: 'Please also fill in the address details. This helps us ensure the inspection invitation is sent to the correct vehicle at the right time. We use the Traficom traffic register to assist with this process.',
        onlineCheckOutInfo: 'When you click the "Book" button at the end, you will be redirected to the payment service',
        contactStation: 'Contact the station (tel. {{ phone }})',
        couldNotFindRegister: 'Registration number not found!',
        iAccept: 'I accept the ',
        inputCampaignCode: 'Enter campaign code',
        showAll: 'Show all',
        noAnswer: 'No answer',
        timeLeft: 'Time remaining',
        showCheapest: 'Show cheapest',
        freeTimes: 'Available times',
        noFreeTimes: 'No available times',
        specialOffer: 'Special offer',
        selected: 'Selected',
        startingPrice: 'Starting from',
        startingPrice_abbr: 'from',
        invoicePrice: 'Invoice (Collector)',
        prepaidPrice: 'Prepaid discount price',
        reservable: 'Available for booking',
        youAreReserving: 'You are booking',
        choosePaymentMethod: 'Select payment method',
        payNow: 'Pay now (Paytrail): {{price}}',
        payWithInvoice: 'Pay by invoice: {{price}}',
        payAtStation: 'Pay at the station: {{price}}',
        nextInspectionBefore: 'Next inspection due by',
        nextAfterInspectionBefore: 'Follow-up inspection by',
        ownerOrOccupant: 'I am the vehicle',
        ownerOccupant: 'Owner / holder',
        other: 'Someone else',
        priceIncludesTraficomFee: 'Price includes Traficom supervision fee {{price}}',
        allowOffers: 'I also want to receive information about offers',
        allowSendingReminders: 'I want to receive a reminder when the next inspection is due',
        viaTxt: 'By text message',
        viaEmail: 'By email',
        noStationsFound: 'No stations found at this location',
        inputRegistrationNumber: 'Enter registration number',
        inputRegistrationInfo: 'Enter vehicle details',
        chooseStation: 'Select station',
        chooseService: 'Select service',
        chooseDatetime: 'Select date and time',
        fillInformation: 'Fill in details',
        accept: 'Accept',
        reserve: 'Book now',
        vehicleInfo: 'Vehicle details',
        getRegisterInfo: 'Get details',
        appBarTitle: 'Inspection Station Ltd',
        registerNumber: 'Registration number',
        getStations: 'Find stations near me',
        registrationDate: 'Registered',
        manufacturer: 'Make',
        model: 'Model',
        findDate: 'Find another time',
        cheapestPrices: 'Best prices',
        showMore: 'Show more',
        unregisteredVehicle: 'Unregistered vehicle',
        vehicleNokConsumption: 'Due to legislative changes and updated equipment requirements, we are currently unable to inspect your vehicle.',
        vehicleNokMassM1: 'Unfortunately, we cannot inspect your vehicle at this time.',
        cookieConsent: {
            title: 'This website uses cookies',
            disclaimer: 'We use tracking and performance cookies. These help us analyze traffic and improve your experience on our site. For example, they track how long you spend on our site and which pages you visit, helping us enhance your experience. The data collected cannot be used to identify individual users.',
            accept: 'Accept',
            refuse: 'Decline',
        },
    },
    selfService: {
        title: 'Self service',
        enterCustomerToken: 'Enter customer number',
        customerToken: 'Customer number',
        customerTokenNotFound: 'Unknown customer number',
        companyCustomer: 'Company customer',
        fetchingVehicleInformation: 'Fetching vehicle information',
        vehicleInformationNotFound: 'Vehicle information not found',
        vehicleInformationNotFoundInfo: 'Check the spelling of the registration number. You can ask for more information at the counter.',
        vehicleFound: 'Vehicle:',
        selectService: 'Select service',
        payWithCard: 'Pay with card',
        payOnline: 'Online payment',
        paymentAbortRequested: 'Cancelling payment transaction',
        waitingForPaymentTerminal: 'Waiting for payment terminal',
        followPaymentTerminalInstructions: 'Follow the payment terminal instructions',
        selectTime: 'Select time',
        selectDriveInHelpText: 'If you have made a reservation or want to come for a drive-in inspection',
        selectCheckInHelpText: 'If you have made a reservation',
        selectDriveIn: 'Check in for inspection',
        selectOtherTimeHelpText: 'If you want to book an inspection for another time',
        selectOtherTime: 'Book an inspection time',
        newReservation: 'New reservation:',
        reserve: 'Reserve',
        reserveAndPay: 'Reserve and pay',
        reservationFound: 'Reservation found:',
        reservationNotFound: 'No reservation found with this registration number',
        signUp: 'Check in',
        paid: 'Paid',
        paymentOngoing: 'Payment in progress',
        paymentViaInvoice: 'Invoice',
        priceFrom: 'From',
        notPaid: 'Not paid',
        reservationSucceeded: 'Reservation successful.',
        youHaveReservation: 'You have a reservation',
        thankYou: 'Thank you for your business!',
        enterRegistrationNumber: 'Enter registration number',
        enterRegistrationNumberInfo: 'You can enter the registration number without a hyphen',
        privacyPolicy: 'Privacy Policy',
        inWorkQueue: 'is now in the work queue.',
        notInWorkQueue: 'Failed to add vehicle to work queue',
        waitForService: 'You can wait for your vehicle to be taken into service.',
        orderInspectionReminder: 'Order a free inspection reminder by filling in the fields below',
        askUserInformation: 'Please provide your contact information',
        selectInspection: 'Periodic inspection',
        selectInspection2: 'Follow-up inspection',
        selectOtherServices: 'Other services',
        selectOrderReminder: 'Order inspection reminder',
        noThankYou: 'No thanks',
        doYouWantToOrderInspectionReminder: 'Would you like to order a free inspection reminder?',
        doYouWantToOrderInspectionReminderInfo: 'The reminder will send you a message when your next inspection is due.',
        screenReturns: 'The screen will return to the main view in',
        inSeconds: 'seconds',
        paymentSucceeded: 'Payment successful',
        terminalNotConnected: 'No connection to payment terminal',
        connect: 'Connect',
        pay: 'Pay',
        confirmEmail: 'Confirm email',
        otherServicesClosed: 'Registration service is closed!',
        chooseService: 'Choose service',
        noServicesNotice: 'Self-service check-in or booking is not available for this vehicle. You can ask for more information at the counter.',
        registrationServices: 'Registration services',
        initialRegistration: 'First registration',
        changeOfOwner: 'Change of owner/holder, transfer notification',
        trafficUseRegistration: 'Registration/deregistration for traffic use',
        usageInformationChange: 'Change of use information (private, commercial, ...)',
        transferPermits: 'Transfer permits',
        licensePlateOrders: 'License plate orders',
        vehicleInsurance: 'Vehicle insurance',
        modificationInspection: 'Modification inspection',
        registrationInspection: 'Registration inspection',
        yourQueueNumberIs: 'Your queue number is',
        pleaseWaitForYourTurn: 'Please wait for the service representative to call your number.',
        registrationCustomersAreServedByQueueNumber: 'Registration customers are served by queue number',
        specialInspectionCustomersAreServedByQueueNumber: 'Special inspection customers are served by queue number',
        takeQueueNumber: 'Take a queue number',
        pleaseHaveRegistrationAndIdReady: 'Please have your registration number and ID ready.',
        prefillTransferForm: 'If this concerns a transfer permit, you can pre-fill the form if you wish.',
        doYouWantToAbort: 'Do you want to abort?',
        abortHelpText: 'Do you want to cancel the transaction and return to the start screen?',
        paymentEvent: 'Payment transaction',
        scanQRCode: 'Scan the QR code with your phone to proceed to online payment',
        giveEmailForOnlinePayment: 'Enter the email address to be linked to the Paytrail online payment',
        emailForOnlinePayment: 'Email address linked to Paytrail online payment',
        onlinePaymentFailed: 'Paytrail online payment failed. You can try the payment again.',
        onlinePaymentChangeEmailInfo: 'Scan the QR code again after changing the email address. Cancel any ongoing payment if necessary.',
        confirm: 'Confirm',
        change: 'Change',
        notice: 'Notice!',
        noticeUnpaid: 'According to the system, the vehicle has unpaid fees. The inspection can be performed and the vehicle can be checked, but an inspection decision cannot be made.',
        noticeUnpaidHelp: 'You can get more detailed information by logging into the Traficom Oma asiointi service at traficom.fi',
        close: 'Close',
        returnToStartScreen: 'Return to start screen',
        returnToStart: 'Return to start',
        acceptTermsOfService: 'Accept terms of service',
        youHaveInspectionReminder: 'Inspection reminder order successful.',
        noticeNotAllowed: 'The vehicle has restrictions according to Traficom\'s system. Most often this is due to unpaid vehicle tax or traffic insurance premium. Due to this restriction, self-service check-in is not possible. You can ask for more information at the counter.',
        checkoutNotification: 'Complete your check-in at the counter',
        futureReservationNotice: 'Please note that your reservation is not for today. You can still check in for drive-in inspection if you wish.',
        futureReservationNoticeNoDriveIn: 'Your reservation is not for today, and check-in is not yet possible.',
        otherReservationNotice: 'Please note that you already have a reservation. You can still make a new reservation if you wish.',
        registrationSuccessMessage: 'Check-in successful.',
        notInWorkQueueInfo: 'Check in at the counter',
        goingToWorkQueue: 'Vehicle is being added to the work queue',
        vehicleNokMassM1: 'Unfortunately, we cannot inspect your vehicle.',
        vehicleNoticeGoToDesk: 'Self-service check-in or booking is not available for this vehicle. You can ask for more information at the counter.',
        reservationFailed: 'nfortunately, there are no more available times for drive-in inspection.',
        printing: 'Printing in progress',
        printError: 'Printing failed',
        checkInErrors: {
            notPaid: 'Check-in is not possible because the payment has not been completed.',
            reservationRemoved: 'The reservation has been cancelled or removed.',
            atjSearchFailed: 'Failed to fetch vehicle information.',
        },
    }
}

const _export: ResourceLanguage = { translation }

export default _export
